/**
 * Banda térmica: rango (°C) y colores del coropleto.
 *
 * Fuente única de verdad: la usan tanto el notificador (render de la capa)
 * como la leyenda compacta, de modo que el color que ve el usuario en el mapa
 * siempre coincide con el de la escala.
 */
export interface TemperatureBand {
  /** Límite inferior inclusive (°C). */
  min: number;
  /** Límite superior exclusivo (°C), salvo en la banda extrema superior. */
  max: number;
  /** Color de relleno del coropleto. */
  color: string;
  /** Color del borde del coropleto. */
  stroke: string;
}

/**
 * Escala térmica (frío → calor). Los cortes son fijos —no dependen del
 * min/max observado— para que el color sea estable y comparable entre
 * actualizaciones (un "rojo" siempre significa el mismo rango).
 */
export const TEMPERATURE_BANDS: TemperatureBand[] = [
  { min: -60, max: 0, color: "#5B7FBF", stroke: "#2F4E86" },
  { min: 0, max: 6, color: "#4FA3D1", stroke: "#2E6E93" },
  { min: 6, max: 12, color: "#5FBFA6", stroke: "#33806C" },
  { min: 12, max: 18, color: "#8FBF5A", stroke: "#5C8433" },
  { min: 18, max: 24, color: "#F2C14E", stroke: "#B4862A" },
  { min: 24, max: 30, color: "#E8853A", stroke: "#A9551B" },
  { min: 30, max: 60, color: "#D3453A", stroke: "#8E241C" },
];

/**
 * Rótulo de eje para cada banda (se alinea al borde izquierdo de su segmento).
 * No se rotulan todas para mantener la leyenda compacta y legible.
 */
export const TEMPERATURE_AXIS_LABELS: Record<number, string> = {
  1: "0°",
  3: "12°",
  5: "24°",
  6: "30°+",
};
